@if (clientType == 3) {
	<div class="amount-container">
		<button class="action decrease" [disabled]="disabled" (click)="decrease()">-</button>
		<input type="number" [disabled]="disabled" [formControlName]="controlName" readonly min="0" max="200" />
		<button class="action increase" [disabled]="disabled" (click)="increase()">+</button>
	</div>
}

@if (clientType == 1) {
	<div class="amount-container">
		<button class="action decrease" [disabled]="disabled" (click)="decrease()">-</button>
		<input type="number" [disabled]="disabled" [formControlName]="controlName" readonly min="0" max="40" />
		<button class="action increase" [disabled]="disabled" (click)="increase()">+</button>
	</div>
}

@if (clientType == 0) {
	<div class="amount-container">
		<button class="action decrease" [disabled]="disabled" (click)="decrease()">-</button>
		<input type="number" [disabled]="disabled" [formControlName]="controlName" readonly min="0" max="3" />
		<button class="action increase" [disabled]="disabled" (click)="increase()">+</button>
	</div>
}
